import AjaxRequest from "../modules/ajax-request";
import GoogleTag from "../modules/google-tag";

class ContactForm {
    constructor(element) {
        this.div = element;
        this.form = "";
        this.url = "";
        this.formFields = "";
        this.formFeedback = "";
        this.loadingElement = "";
        this.showRecaptcha = false;
        this.recaptchaLoaded = false;
        this.reCaptchaAction = "contact_form";
        this.reCaptchaWidget = "contact_form";
        this._ajaxCallData = [];
        this.googleTag = new GoogleTag();

        this.init();
        this.getData();
        this.clearData();
        this.bindEvents();
    }

    init() {
        this.form = this.div.querySelector("form");
        this.loadingElement = this.div.querySelector(".add-load-element");
        this.formFields = this.form.querySelectorAll('[data-id="form-field"]');
        this.formFeedback = this.form.querySelector('[data-id="form-feedback"]');
    }

    getData() {
        [
            this._id,
            this._ajaxCallData['url'],
            this._ajaxCallData['controller'],
            this._ajaxCallData['action'],
            this._ajaxCallData['method'],
            this._ajaxCallData['parameters'],
            this._ajaxCallData['payload'],
            this._ajaxCallData['signature'],
            this.showRecaptcha,
        ] = Object.values(this.div.dataset)
        if ((this.showRecaptcha === 1) || (this.showRecaptcha === "1")) {
            this.showRecaptcha = true;
        } else {
            this.showRecaptcha = false;
        }
    }

    clearData() {
        let attrs = Array.from(this.div.attributes).filter(attr => attr.name.startsWith('data-'));
        attrs.forEach(attr => this.div.removeAttribute(attr.name));
    }

    bindEvents() {
        let _this = this;

        this.form.addEventListener("submit", function (event) {
            if (_this.showRecaptcha === true) {
                _this.getRecaptcha3Token(event);
            } else {
                _this.submitForm(event);
            }
        });

        this.formFields.forEach(function (field) {
            field.addEventListener("click", function () {
                if (!_this.recaptchaLoaded) {
                    _this.recaptchaLoaded = true;
                    let _event = new CustomEvent('reCaptcha_domInjection');
                    document.dispatchEvent(_event);
                }
            });
        });

        document.addEventListener('recaptcha3_token_generated', function (event) {
            event.preventDefault();
            let _target = event.detail.target;
            if (_target === _this.reCaptchaWidget) {
                _this.addRecaptchaToken(event);
                _this.submitForm(event);
            }
        });
    }

    getRecaptcha3Token(event) {
        event.preventDefault();
        let _eventDetail = { 'detail': { 'origin': this.reCaptchaWidget, 'action': this.reCaptchaAction } };
        let _event = new CustomEvent('recaptcha3_generate_token', _eventDetail);
        document.dispatchEvent(_event);
    }

    addRecaptchaToken(event) {
        event.preventDefault();
        let _recaptcha3Input = this.form.querySelector('#contact_form_recaptcha3');
        if (_recaptcha3Input !== undefined) {
            _recaptcha3Input.value = event.detail.token;
        }
    }

    submitForm(event) {
        event.preventDefault();

        let _this = this;
        let _loadingElement = this.loadingElement;

        let ajaxRequest = new AjaxRequest({
            elementToAddLoading: _loadingElement,
            successCallback: function (response) {
                _this.form.innerHTML = response.message;
                _this.init();
                _this.formFeedback.classList.add("is-success");
                _this.clearFormFields();
                _this.googleTag.trackConversion("contact_form");
            },
            errorCallback: function (response) {
                _this.form.innerHTML = response.responseJSON.message;
                _this.init();
                _this.formFeedback.classList.add("is-failure");
                _this.clearFormFields();
            }
        });

        this.formFeedback.classList.remove("is-success");
        this.formFeedback.classList.remove("is-failure");

        let _formData = Array.from(new FormData(this.form)).reduce((obj, [name, value]) => {
            obj[name] = value;
            return obj;
        }, {});

        let _url = this._ajaxCallData['url'];
        ajaxRequest.makeCall(_url, Object.assign({
            "controller": this._ajaxCallData['controller'],
            "action": this._ajaxCallData['action'],
            "method": this._ajaxCallData['method'],
            "_parameters": this._ajaxCallData['parameters'],
            "payload": this._ajaxCallData['payload'],
            "signature": this._ajaxCallData['signature']
        }, _formData));
    }

    clearFormFields() {
        let _privacyCheckBox = this.form.querySelector('#contact_form_legal');
        _privacyCheckBox.checked = false;

        let _event = new CustomEvent("recaptcha_reset");
        document.dispatchEvent(_event);
    }
}

export default ContactForm;